export var Placement;
(function (Placement) {
    Placement["UNKNOWN"] = "UNKNOWN";
    Placement["HOME_PAGE"] = "HOME_PAGE";
    Placement["SIDEBAR"] = "SIDEBAR";
    Placement["EDITOR_3_APPS_PAGE"] = "EDITOR_3_APPS_PAGE";
    Placement["EDITOR_3_RECOMMENDED_APPS"] = "EDITOR_3_RECOMMENDED_APPS";
    Placement["EDITOR_3_RELATED_APPS"] = "EDITOR_3_RELATED_APPS";
})(Placement || (Placement = {}));
export var SectionType;
(function (SectionType) {
    SectionType["UNKNOWN"] = "UNKNOWN";
    SectionType["CATEGORY_CAROUSEL"] = "CATEGORY_CAROUSEL";
    SectionType["SIDEBAR_TITLE"] = "SIDEBAR_TITLE";
    SectionType["SIDEBAR_DIVIDER"] = "SIDEBAR_DIVIDER";
    SectionType["COLLECTION_LINK"] = "COLLECTION_LINK";
    SectionType["CATEGORY_LINK"] = "CATEGORY_LINK";
    SectionType["APP_GROUP"] = "APP_GROUP";
})(SectionType || (SectionType = {}));
export var AppGroupType;
(function (AppGroupType) {
    AppGroupType["UNKNOWN"] = "UNKNOWN";
    AppGroupType["COLLECTION"] = "COLLECTION";
    AppGroupType["PROMO"] = "PROMO";
})(AppGroupType || (AppGroupType = {}));
export var PricingLabelType;
(function (PricingLabelType) {
    PricingLabelType["UNKNOWN"] = "UNKNOWN";
    PricingLabelType["FREE"] = "FREE";
    PricingLabelType["FREE_TO_INSTALL"] = "FREE_TO_INSTALL";
    PricingLabelType["FREE_TRIAL_DAYS"] = "FREE_TRIAL_DAYS";
    PricingLabelType["FREE_PLAN_AVAILABLE"] = "FREE_PLAN_AVAILABLE";
    PricingLabelType["RECURRING_PRICE"] = "RECURRING_PRICE";
    PricingLabelType["ONE_TIME_PRICE"] = "ONE_TIME_PRICE";
})(PricingLabelType || (PricingLabelType = {}));
export var AppBadgeType;
(function (AppBadgeType) {
    AppBadgeType["UNKNOWN_APP_BADGE"] = "UNKNOWN_APP_BADGE";
    AppBadgeType["WIX_CHOICE"] = "WIX_CHOICE";
    AppBadgeType["PREMIUM_BENEFIT"] = "PREMIUM_BENEFIT";
    AppBadgeType["WIX_SALE"] = "WIX_SALE";
    AppBadgeType["DEV_SALE"] = "DEV_SALE";
    AppBadgeType["BETA"] = "BETA";
    AppBadgeType["APP_BENEFIT"] = "APP_BENEFIT";
})(AppBadgeType || (AppBadgeType = {}));
export var BundleAppType;
(function (BundleAppType) {
    BundleAppType["DEFAULT"] = "DEFAULT";
    BundleAppType["COUPON"] = "COUPON";
})(BundleAppType || (BundleAppType = {}));
export var DiscountBadgePayloadDiscountType;
(function (DiscountBadgePayloadDiscountType) {
    DiscountBadgePayloadDiscountType["DISCOUNT_TYPE_UNSPECIFIED"] = "DISCOUNT_TYPE_UNSPECIFIED";
    DiscountBadgePayloadDiscountType["PERCENTAGE"] = "PERCENTAGE";
    DiscountBadgePayloadDiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(DiscountBadgePayloadDiscountType || (DiscountBadgePayloadDiscountType = {}));
export var Status;
(function (Status) {
    /** current market listing in the Dev Center. */
    Status["DRAFT"] = "DRAFT";
    /** published market listing in the App Market. */
    Status["PUBLISHED"] = "PUBLISHED";
    /** approved market listing in the App Market. */
    Status["APPROVED"] = "APPROVED";
})(Status || (Status = {}));
export var SortType;
(function (SortType) {
    SortType["COUNTRY_CODE"] = "COUNTRY_CODE";
    SortType["APP_MARKET_SCORE"] = "APP_MARKET_SCORE";
    SortType["DEALER"] = "DEALER";
    SortType["DATE_CREATED"] = "DATE_CREATED";
    SortType["REVIEWS_RATING"] = "REVIEWS_RATING";
    SortType["MOST_INSTALLED"] = "MOST_INSTALLED";
    SortType["MANUAL"] = "MANUAL";
    SortType["ML_MODEL_RANKING"] = "ML_MODEL_RANKING";
})(SortType || (SortType = {}));
//# sourceMappingURL=types.impl.js.map